export default __webpack_public_path__ + "static/media/background.ec3a8b8e.png";